import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { FiArrowRight } from "react-icons/fi";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const callToActionData = {
    title: "About E-Book",
    subtitle: "In the Standout From The Crowd booklet; How to find your passion and turn It Into business. I have simplified the processes of finding out one’s own passion from their talent bucket that Almighty Allah has blessed them with. And if anybody wants to Standout From The Crowd in any Industry of your Dream then I have given 7 (Seven) Proven Strategies in the book to follow. I believe regardless of your age and current situation you must chase your true calling and purpose of life. And I believe It’s your responsibility to do so. My commitment Is really to help you with this proven steps so you can get to the pinnacle of success too.",
    btnText: "DOWNLOAD FREE PDF",
    image: "/images/pdf.jpg" // Update this path as needed
}

const LinkPdf = () => {
    return (
        <div className="rn-callto-action clltoaction-style-default style-5 py-5">
            <div className="container">
                <div className="row align-items-center theme-shape">
                    
                    {/* Left Column (Image) */}
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <ScrollAnimation animateIn="fadeInLeft" animateOnce={true}>
                            <div className="text-center text-lg-center">
                                <img 
                                    src={callToActionData.image} 
                                    alt="E-Book Cover" 
                                    className="img-fluid rounded"
                                    style={{ maxWidth: "100%", objectFit: "cover" }}
                                />
                            </div>
                        </ScrollAnimation>
                    </div>

                    {/* Right Column (Text + Button) */}
                    <div className="col-lg-6">
                        <div className="content text-center text-lg-start">
                            <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                                <h2 className="title">{callToActionData.title}</h2>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                                <p className="mt-2 fs-2">{callToActionData.subtitle}</p>
                            </ScrollAnimation>

                            <ScrollAnimation animateIn="fadeInUp" animateOnce={true}>
                                <div className="call-to-btn mt-3">
                                    <Link className="btn-default btn-icon" to="/pdf">
                                        {callToActionData.btnText} <i className="icon"><FiArrowRight /></i>
                                    </Link>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default LinkPdf;
